export const environment = {
  production: false,
  apiBaseUrl: '/bff',
  keycloak: {
    url: 'https://test.keycloak.ndc.net.vn',
    realm: 'ndc-test',
    clientId: 'ndc-entertainment-web'
  },
  playbackBuffer: {
    minBufferSeconds: 30,
    targetBufferSeconds: 90,
    maxBufferSeconds: 180,
    maxBufferMb: 280
  }
};
